import { put, select, takeLatest } from '@redux-saga/core/effects';

import { isFullAccessForFree } from '@sm/api';
import {
  SET_USER_PROFILE,
  setNotFilledCompanyCountryWarningShowAction,
  setPpcNeedsReconnectWarningShowAction
} from 'seller/store/actions';
import { userPreferencesSelector, userSelector } from 'seller/store/reducers';
import {
  setAccessDeniedWarningShowAction,
  setRecommendedAlternativeBannerShowAction,
  setRecommendedAlternativeBannerSkippedAction,
  setServiceEndingBannerShowAction,
  setServiceEndingBannerSkippedAction,
  setSkippedDisconnectedAccountsAction,
  setSkippedPpcNeedsReconnectAction,
  setSpApiExpiredWarningShowAction,
  setSpApiExpiredWarningSkippedAction,
  SKIP_ACCESS_DENIED_WARNING,
  SKIP_PPC_NEEDS_RECONNECT_WARNING,
  SKIP_RECOMMENDED_ALTERNATIVE_BANNER,
  SKIP_SERVICE_ENDING_BANNER,
  SKIP_SP_API_EXPIRED_WARNING
} from './action';

export function* userPreferencesSaga(action) {
  const { type } = action;
  const {
    accessDeniedSkipped,
    ppcNeedsReconnectSkipped,
    spApiExpiredWarningSkipped,
    serviceEndingBannerSkipped,
    recommendedAlternativeBannerSkipped
  } = yield select(userPreferencesSelector);
  const { profile } = yield select(userSelector);
  const {
    notConnectedSPA,
    pcc_needs_reconnect: pccNeedsReconnect,
    company_residence_country: companyResidenceCountry,
    sp_api_connection_expired: spApiConnectionExpired,
    billing,
    is_rf_user: isRfUser,
    agency
  } = profile;

  if (action.type === SET_USER_PROFILE) {
    if (billing && !isFullAccessForFree(profile)) {
      yield put(setNotFilledCompanyCountryWarningShowAction(!companyResidenceCountry));
    }
    yield put(setAccessDeniedWarningShowAction(notConnectedSPA && !accessDeniedSkipped));
    if (!notConnectedSPA && accessDeniedSkipped) {
      yield put(setSkippedDisconnectedAccountsAction(false));
    }
    yield put(
      setPpcNeedsReconnectWarningShowAction(pccNeedsReconnect && !ppcNeedsReconnectSkipped)
    );
    if (!pccNeedsReconnect && ppcNeedsReconnectSkipped) {
      yield put(setSkippedPpcNeedsReconnectAction(false));
    }
    yield put(
      setSpApiExpiredWarningShowAction(spApiConnectionExpired && !spApiExpiredWarningSkipped)
    );
    if (!spApiConnectionExpired && spApiExpiredWarningSkipped) {
      yield put(setSpApiExpiredWarningSkippedAction(false));
    }
  }

  if (type === SKIP_ACCESS_DENIED_WARNING) {
    yield put(setSkippedDisconnectedAccountsAction(true));
    yield put(setAccessDeniedWarningShowAction(false));
  }

  if (type === SKIP_PPC_NEEDS_RECONNECT_WARNING) {
    yield put(setSkippedPpcNeedsReconnectAction(true));
    yield put(setPpcNeedsReconnectWarningShowAction(false));
  }

  if (action.type === SKIP_SP_API_EXPIRED_WARNING) {
    yield put(setSpApiExpiredWarningSkippedAction(true));
    yield put(setSpApiExpiredWarningShowAction(false));
  }

  if (action.type === SET_USER_PROFILE) {
    yield put(
      setServiceEndingBannerShowAction(!isRfUser && !agency && !serviceEndingBannerSkipped)
    );
  }

  if (action.type === SKIP_SERVICE_ENDING_BANNER) {
    yield put(setServiceEndingBannerSkippedAction(true));
    yield put(setServiceEndingBannerShowAction(false));
  }

  if (action.type === SET_USER_PROFILE) {
    yield put(
      setRecommendedAlternativeBannerShowAction(
        !isRfUser && !agency && !recommendedAlternativeBannerSkipped
      )
    );
  }

  if (action.type === SKIP_RECOMMENDED_ALTERNATIVE_BANNER) {
    yield put(setRecommendedAlternativeBannerSkippedAction(true));
    yield put(setRecommendedAlternativeBannerShowAction(false));
  }
}

export function* userPreferencesSagaWatcher() {
  yield takeLatest(
    [
      SET_USER_PROFILE,
      SKIP_ACCESS_DENIED_WARNING,
      SKIP_PPC_NEEDS_RECONNECT_WARNING,
      SKIP_SP_API_EXPIRED_WARNING,
      SKIP_SERVICE_ENDING_BANNER,
      SKIP_RECOMMENDED_ALTERNATIVE_BANNER
    ],
    userPreferencesSaga
  );
}
